import { Component, input, signal } from '@angular/core';
import { AbstractControl, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconComponent } from '../../icon/icon.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'htx-file-upload-field',
  imports: [
    FormsModule,
    IconComponent,
    ReactiveFormsModule,
    CommonModule
  ],
  templateUrl: './file-upload-field.component.html',
  styleUrl: './file-upload-field.component.scss'
})
export class FileUploadFieldComponent {
  /** The FormControl that manages the file upload */
  ctrl = input.required<AbstractControl>();

  /** Icon name to display (default: 'cloud_upload') */
  uploadIcon = input<string>('cloud_upload');

  /** Custom text for main upload label */
  uploadText = input<string>();

  /** Custom text for drag & drop hint */
  dragDropText = input<string>();

  /** Custom text for change file hint */
  changeText = input<string>();

  /** Accepted file types (e.g., 'application/pdf' or '.pdf,image/*') */
  acceptedFileTypes = input<string>();

  /** Indicates whether a file is being dragged over the drop area */
  isDragging = signal(false);

  /**
   * Returns the control as a FormControl for direct access to its properties and methods.
   */
  getControl(): FormControl {
    return this.ctrl() as FormControl;
  }

  /**
   * Formats bytes to human-readable size string
   */
  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
  }

  /** Handler for drag leave event */
  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (!this.getControl().disabled) {
      this.isDragging.set(false);
    }
  }

  /** Handler for drag over event */
  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (!this.getControl().disabled) {
      this.isDragging.set(true);
    }
  }

  /** Handler for drop event */
  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (this.getControl().disabled) {
      return;
    }

    this.isDragging.set(false);

    if (event.dataTransfer?.files) {
      const file = event.dataTransfer.files[0];
      this.getControl().setValue(file);
      this.getControl().setErrors(null);
    }
  }

  /** Handler for file selection via input */
  onFileSelected(event: Event) {
    const element = event.currentTarget as HTMLInputElement;

    if (this.getControl().disabled) {
      return;
    }

    if (element.files) {
      const file = element.files[0];
      this.getControl().setValue(file);
      this.getControl().setErrors(null);
    }
  }
}
